//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import mixin from './mixin'
export default {
    mixins: [mixin],
    methods: {
        next () {
            this.$router.push({
                name: 'first_payment_result'
            })
        }
    }
}
